module.exports = __webpack_public_path__ + "static/img/5.def9861.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/5.png
// module id = KYVd
// module chunks = 0